import classNames from 'classnames';
import React, { useCallback, useRef, useState } from 'react';
import { Form as BForm } from 'react-bootstrap';
import './FormControl.scss';
import PropTypes from 'prop-types';

/**
 * @typedef FormControlCustom
 * @prop {any} prepend
 * @prop {any} append
 * @prop {boolean} textarea
 * @prop {boolean} resizable
 * @prop {number} rows
 *
 * @typedef {import('react-bootstrap').FormProps & FormControlCustom} FormControlProps
 */

/**
 * @param {FormControlProps} params
 * @return
 */
const FormControl = ({
  className,
  onClick,
  onFocus,
  onBlur,
  disabled,
  error,
  textarea,
  prepend,
  append,
  rows = 3,
  fill,
  resizable,
  ...params
}) => {
  const form = useRef();
  const input = useRef();
  const [focused, setFocused] = useState(className && className.includes('focus'));

  const handleClick = useCallback((e) => {
    if (e.target.nodeName === 'BUTTON') return;

    input.current.focus();
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  const handleFocus = useCallback(() => {
    setFocused(true);
    if (onFocus) {
      onFocus();
    }
  }, [onFocus]);

  const handleBlur = useCallback(() => {
    setFocused(false);
  }, [onBlur]);

  return (
    <div
      ref={form}
      className={classNames('form-gradient', {
        focus: focused || className && className.includes('focus'),
        disabled,
        textarea,
        error,
        'h-100': fill,
        hover: className && className.includes('hover'),
      }, className)}
      onClick={handleClick}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      {prepend}
      <div className="background-gradient" />
      {
        textarea
          ? <textarea
            className={classNames("form-control", { 'not-resizable': !resizable })}
            rows={rows}
            onBlur={onBlur}
            disabled={disabled}
            ref={input}
            {...params}
          />
          : <BForm.Control
            onBlur={onBlur}
            type="__classPrivateFieldSet"
            disabled={disabled}
            ref={input}
            {...params}
          />
      }
      {append}
    </div>
  );
};

FormControl.propTypes = {
  className: PropTypes.any,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  textarea: PropTypes.bool,
  prepend: PropTypes.any,
  append: PropTypes.any,
  rows: PropTypes.number,
  fill: PropTypes.bool,
  resizable: PropTypes.bool,
};

export default React.memo(FormControl);
